import React from 'react';
import { MdKeyboardBackspace, MdAdd } from 'react-icons/md';
import _ from 'lodash';
 import { Formik } from 'formik';
import { InputLabel, Select } from '~/components/form';
import Tabs from '~/components/tabs';
import { IconButton } from '~/components/crud/styles';
import confirm from '~/components/confirm';
import { Row, TableContainer, AccreditContainer } from '~/views/events/accredit-approval/styles';
import { formats } from '~/helper';
import EmployeesForm from '~/views/events/accredit-approval/form-employees';
import EmployeeModal from '~/views/events/accredit-approval/modal-employee';
import CredentialModal from '~/views/events/accredit-approval/modal-credential';
import PressMailModal from '~/views/events/accredit-approval/modal-press-mail';
import EmployeeAddModal from '~/views/events/matchday/modal-employee';
import useEvents from '~/view-data/use-events';
import useEventAccreditApproval from '~/view-data/use-event-accredit-approval';
import { TabSupplier } from '~/views/events/accredit-approval/tab-supplier';
import { TabPress } from '~/views/events/accredit-approval/tab-press';

const getTabs = ({supplierList, pressList}) => {
  return [
    { id: 'supplier', label: `Fornecedores (${_.size(supplierList)})`, component: TabSupplier },
    { id: 'press', label: `Imprensa (${_.size(pressList)})`, component: TabPress },
  ];
};

const columns = [
    {
      name: 'CNPJ/Nº Registro',
      selector: 'company',
      width: '150px',
      format: (row) => formats.cnpj(_.get(row, 'company.identify')) || _.get(row, 'company.identify') || ''
    },
    {
      name: 'Nome',
      selector: 'company',
      format: (row) => _.get(row, 'company.name')
    },
    {
      name: 'Colaboradores',
      selector: 'status',
      right: true,
      width: '120px',
      format: (row) => _.get(row, 'status.total') || 0
    },
    {
      name: 'Aprovados',
      selector: 'status',
      right: true,
      width: '120px',
      format: (row) => _.get(row, 'status.approved') || 0
    },
    {
      name: 'Reprovados',
      selector: 'status',
      right: true,
      width: '120px',
      format: (row) => _.get(row, 'status.reproved') || 0
    }
  ];

const sortSupplier = (array) => {
  return _.orderBy(array, (r) => _.get(r, 'company.name'), ['asc']);
};

function AccreditApproval({acls, history}) {
  const { state, actions } = useEventAccreditApproval(),
    { actions: eventActions } = useEvents(),
    model = _.get(state, 'model') || {},
    isPress = _.get(state, 'selected.company.isPress'),
    supplierList = sortSupplier(_.filter(model.suppliers, (r) => !_.get(r, 'company.isPress'))),
    pressList = sortSupplier(_.filter(model.suppliers, (r) => !!_.get(r, 'company.isPress')));

  const handleAction = async (data, action) => {
    let actionText = /^(approve)$/.test(action) ? 'aprovar ' : 'reprovar ';

    if (action === 'approve' && data.status === 'approved') {
      actionText = 'desfazer a aprovação d';
    } else if (action === 'reprove' && data.status === 'reproved') {
      actionText = 'desfazer a reprovação d';
    }
      
    let text = `Deseja realmente ${actionText}o colaborador "${_.get(data, 'person.name')}"?`;

    if (/^(approveAll|reproveAll)$/.test(action)) {
      actionText = /^(approveAll)$/.test(action) ? 'aprovar' : 'reprovar';
      text = `Deseja realmente ${actionText} todos colaboradores deste fornecedor?`;
    }

    let result = await confirm.show({ title: 'Atenção', text });

    if (result) {
      actions.update(state.selected, data, action);
    }
  };

  const handleCreateCredentials = (mode, emails) => {
    actions.createCredentials(state.selected, mode, emails);
  };


  return (
    <AccreditContainer>
      <div className="contents">
        <div className="form-data">
          <Row span={4}>
            <InputLabel
              label='Evento'
              value={_.get(model, 'name')}
              />

            <InputLabel
              label='Tipo'
              value={_.get(model, 'eventType.name')}
              />

            <InputLabel
              label='Local'
              value={_.get(model, 'place.name')}
              />

            <InputLabel
              label='Gerente'
              value={_.get(model, 'manager.name')}
              />
          </Row>

          <Row span={4}>
            <Formik>
              <Select
                name="status"
                label="Fase"
                value={_.get(model, 'status')}
                options={{ values: [
                  { value: 'accreditation', label: 'Credenciamento' },
                  { value: 'checklist', label: 'Checklist' },
                  { value: 'running', label: 'Match Day' },
                ]}}
                onChange={(evt) => eventActions.changeStatus(_.get(model, 'id'), evt.target.value)}
                />
            </Formik>

            <InputLabel
              label='Data início Credenciamento'
              value={formats.dateTimeZone(_.get(model, 'accreditationStartDate'), 'dd/MM/yyyy')}
              />

            <InputLabel
              label='Data término Credenciamento'
              value={formats.dateTimeZone(_.get(model, 'accreditationEndDate'), 'dd/MM/yyyy')}
              />

            <InputLabel
              label='Data do Evento'
              value={formats.dateTimeZone(_.get(model, 'eventDate'), 'dd/MM/yyyy')}
              />
          </Row>
        </div>

        <TableContainer showForm={state.showForm} rightFlex="0 0 50%">
          <div className='list'>
            <Tabs
              tabs={getTabs({ supplierList, pressList })}
              initialTab="supplier"
              columns={columns}
              onRowClicked={actions.loadDetail}
              supplierList={supplierList}
              pressList={pressList}
              />
          </div>

          {state.showForm && (
            <div className='form'>
              <EmployeesForm
                loading={state.formLoading}
                supplier={state.selected}
                detail={state.detail || {}}
                onClose={actions.hideDetail}
                onEdit={actions.openEditModal}
                exportPersonsXlsx={actions.exportPersonsXlsx}
                onPressMail={actions.openPressMailModal}
                onAction={handleAction}
                onCreateCredentials={actions.openCredentialModal}
                />
            </div>
          )}
        </TableContainer>
      </div>

      <div className='toolbar'>
        <IconButton title="Cancelar" disabled={false} onClick={() => history.push('/events')}>
          <MdKeyboardBackspace />
        </IconButton>

        <IconButton title="Adicionar" disabled={false} onClick={actions.openEmployeeModal}>
          <MdAdd />
        </IconButton>
      </div>

      <EmployeeModal
        loading={state.modalLoading}
        data={state.modalData || {}}
        handleOnSubmit={actions.saveEditModal}
        isOpen={state.showModal}
        onListPersons={actions.listPersons}
        onListRoles={actions.listRoles}
        closeModal={actions.closeEditModal}
        title={<>{isPress ? 'Editar colaboradores da imprensa' : 'Editar Colaborador'}</>}
        />

      <CredentialModal
        loading={state.modalLoading}
        data={state.modalData || {}}
        handleOnSubmit={handleCreateCredentials}
        isOpen={state.showCredentialModal}
        closeModal={actions.closeCredentialModal}
        title={<>Gerar credenciais</>}
        />

      <PressMailModal
        loading={state.modalLoading}
        data={state.modalData || {}}
        handleOnSubmit={actions.submitPressMail}
        isOpen={state.showPressMailModal}
        closeModal={actions.closePressMailModal}
        title={<>Enviar email para imprensa</>}
        />

      <EmployeeAddModal
        loading={state.modalLoading}
        data={state.modalData || {}}
        handleOnSubmit={actions.saveEmployeeModal}
        isOpen={state.showEmployeeModal}
        onListRoles={actions.listRoles}
        onListPersons={actions.listPersonsWithSupplier}
        onListSuppliers={actions.listSuppliers}
        closeModal={actions.closeEmployeeModal}
        title={<>Novo Colaborador</>}
        />
        
    </AccreditContainer>
  );
}

export default AccreditApproval;
